import { useEffect, useState } from 'react';
import { adminApi } from '@/lib/adminApi';
import { TEXT_STYLES, styleCss, resetTextStylesCache } from '@/designer/textStyles';

// Admin: choose which curated text styles customers see in the textile designer.
export const AdminTextStyles = () => {
  const [disabled, setDisabled] = useState(null), [state, setState] = useState('');
  useEffect(() => { adminApi('/text-styles').then(r => setDisabled(r.disabled || [])).catch(e => setState(e.message)); }, []);
  const toggle = async id => {
    const next = disabled.includes(id) ? disabled.filter(x => x !== id) : [...disabled, id];
    setDisabled(next); setState('Speichert …');
    try { await adminApi('/text-styles', { method: 'PUT', body: { disabled: next } }); resetTextStylesCache(); setState('Gespeichert'); } catch (e) { setState(e.message); }
  };
  return <section className="admin-text-styles" data-testid="admin-text-styles">
    <h2>Text-Stile (T-Shirt-Designer)</h2>
    <p>Aktive Stile erscheinen bei Textilien im Chip „Effekte“. Ein Klick blendet einen Stil ein oder aus.</p>
    {disabled && <div className="admin-style-grid">{TEXT_STYLES.map(s => { const on = !disabled.includes(s.id); return <button key={s.id} type="button" className={`admin-style-tile ${on ? 'on' : 'off'}`} aria-pressed={on} onClick={() => toggle(s.id)} data-testid={`admin-text-style-${s.id}`}>
      <span className="admin-style-sample" style={{ background: s.bg }}><span style={styleCss(s)}>Aa</span></span><span>{s.name}</span><small>{on ? 'Aktiv' : 'Ausgeblendet'}</small>
    </button>; })}</div>}
    {state && <small role="status" data-testid="admin-text-styles-status">{state}</small>}
  </section>;
};
